import { Box } from "@mui/material";

interface GridColProps {
  totalCol?: string | number;
  minColWidth?: string;
  gridTemplateColumns?: string;
  gap: React.ComponentProps<typeof Box>["gap"];
  children?: React.ReactNode;
}

const GridCol: React.FC<GridColProps> = ({
  totalCol = "auto-fill",
  minColWidth = "auto-fill",
  gridTemplateColumns,
  gap,
  children,
}) => {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns:
          gridTemplateColumns ||
          `repeat(${totalCol}, minmax(${minColWidth}, 1fr))`,
      }}
      gap={gap}
    >
      {children}
    </Box>
  );
};

export default GridCol;
